module.exports = __webpack_public_path__ + "static/media/ventura_college_logo.7af58848.png";